import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { pushIf } from "./utils/pushIf";
import { initialState } from "./initialState";

const reduceConfigureProjectToolsNotificationState = createStateReducer(
  initialState,
  {
    [events.configureProjectToolsSucceeded]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "configureProjectTools",
          flags: ["success"],
          args: { success: "true" },
        },
        state.queue,
      ),
    }),
    [events.configureProjectToolsFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "configureProjectTools",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceConfigureProjectToolsNotificationState };
